import { PressableProps, StyleSheet, ViewStyle } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { Pressable } from "react-native-gesture-handler";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { ComponentProps } from "react";

const Chip = ({
  style,
  text,
  icon,
}: {
  style?: ViewStyle;
  text: string;
  icon?: ComponentProps<typeof MaterialCommunityIcons>["name"];
} & PressableProps) => {
  const { colors } = useTheme();

  return (
    <Pressable
      style={[
        {
          paddingHorizontal: 12,
          paddingVertical: 6,
          borderRadius: 8,
          backgroundColor: colors.card,
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: colors.border,
        },
        style,
      ]}
    >
      <ThemedText
        style={{
          fontSize: 12,
          fontWeight: "500",
          color: colors.text,
        }}
      >
        {text}
      </ThemedText>
      <MaterialCommunityIcons name={icon} />
    </Pressable>
  );
};

export default Chip;
